// extracted by mini-css-extract-plugin
module.exports = {"container":"landing_container__2EQE8","btnLanding":"landing_btnLanding__3GSo9","btn":"landing_btn__1537K"};